import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { isEmpty, trim, get, omit } from 'lodash';
import { bulkSend, clearBulkSendFilters, loadBulkSendFilters } from '../../actions/chat';
import { hideModal } from '../../actions/internal';

import BulkMessage from '../../components/bulksending/BulkMessage';
import BulkMessageRecipients from '../../components/bulksending/BulkMessageRecipients';

const extractValues = (items) => {
  return items.map((item) => item.value);
};

class BulkSendingModal extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    isProcessing: PropTypes.bool.isRequired,
    withScope: PropTypes.object.isRequired,
    bulkSend: PropTypes.func.isRequired,
    clearBulkSendFilters: PropTypes.func.isRequired,
    hideModal: PropTypes.func.isRequired,
    loadBulkSendFilters: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      body: '', bodyEs: '', pushTitle: '', pushTitleEs: '', pushText: '', pushTextEs: '',
      ...this.initFormProps(), isProcessing: false,
    };
  }

  componentDidMount() {
    this.props.loadBulkSendFilters({ source: 'init' });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.meta.partner !== this.props.meta.partner) {
      this.setState(this.initFormProps());
    }
  }

  initFormProps() {
    return {
      partner: this.props.meta.partner,
      accountIds: [],
      cohortIds: this.props.meta.cohortIds || [],
      groupIds: this.props.meta.groupIds || [],
      ageRanges: this.props.meta.ageRanges || [],
      cardIds: this.props.meta.cardIds || [],
      programContentEntryIds: this.props.meta.programContentEntryIds || [],
    };
  }

  onCancel = () => {
    this.props.hideModal();
  }

  onPartnerChange = (selectedOption) => {
    const partner = selectedOption && selectedOption.value;
    partner ? this.props.loadBulkSendFilters({ partner }) : this.props.clearBulkSendFilters();
  }

  onCardChange = (cardIds) => {
    this.setState({ cardIds: extractValues(cardIds) });
  }

  onProgramContentChange = (programContentEntryIds) => {
    this.setState({ programContentEntryIds: extractValues(programContentEntryIds) });
  }

  onAccountChange = (accountIds) => {
    this.setState({ accountIds: extractValues(accountIds) });
  }

  onCohortChange = (cohortIds) => {
    this.setState({ cohortIds: extractValues(cohortIds) });
  }

  onGroupChange = (groupIds) => {
    this.setState({ groupIds: extractValues(groupIds) });
  }

  onAgeRangeChange = (ageRanges) => {
    this.setState({ ageRanges: extractValues(ageRanges) });
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }


  onSend = () => {
    const { cohortIds, groupIds, accountIds, ageRanges } = this.state;

    if (isEmpty(groupIds) && isEmpty(cohortIds) && isEmpty(accountIds) && isEmpty(ageRanges)) {
      alert(this.props.t('modals.bulkSendValidation'));
      return;
    }

    this.props.bulkSend(omit({ ...this.state, partnerIds: [this.props.meta.partner] }, ['partner', 'isProcessing']));
  }

  render() {
    const { body, bodyEs, cardIds, programContentEntryIds } = this.state;
    const clsSend = classNames('o-sp-button o-sp-button--note o-sp-button--primary',
      { 'u-disabled': (isEmpty(trim(body)) && isEmpty(trim(bodyEs)) && isEmpty(cardIds) && isEmpty(programContentEntryIds)) ||
                       this.props.isProcessing || !this.props.meta.partner }
    );
    return (
      <div className='column small-12 u-margin-top--base u-margin-bottom--base'>
        <h2 className='u-txt--base'><b>{this.props.t('modals.bulkMessageSending')}</b></h2>
        <hr className='u-margin-top--zero'/>
        <BulkMessageRecipients
          meta={this.state}
          filters={this.props.filters}
          auth={this.props.auth}
          withScope={this.props.withScope}
          onAccountChange={this.onAccountChange}
          onCohortChange={this.onCohortChange}
          onGroupChange={this.onGroupChange}
          onPartnerChange={this.onPartnerChange}
          onAgeRangeChange={this.onAgeRangeChange}
        />
        <div className='row'>
          <BulkMessage message={this.state} filters={this.props.filters} onChange={this.onChange}
            onProgramContentChange={this.onProgramContentChange} onCardChange={this.onCardChange} />
          <div className='column small-12'>
            <a className={clsSend} onClick={this.onSend}>
              { this.props.isProcessing && <i className='o-spinner-dual'></i> }
              {this.props.t('actions.send')}
            </a>
            <a className='o-sp-button--note cs-txt-link--sp-blue' onClick={this.onCancel}>{this.props.t('actions.cancel')}</a>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth,
    isProcessing: get(state.modal.meta, 'isProcessing', false),
    filters: get(state.modal.meta, 'filters', {}),
    meta: {
      ...get(state.modal.meta, 'meta', {}),
      ...get(ownProps, 'meta', {}),
    },
    withScope: get(state.modal.meta, 'withScope', {}),
  };
};

export default connect(mapStateToProps, { bulkSend, clearBulkSendFilters, loadBulkSendFilters, hideModal })(withTranslation()(BulkSendingModal));
